<template>
    <div v-if="showApp">
        <page-contrat-gestion></page-contrat-gestion>
    </div>
</template>
  
<script>

import PageContratGestion from "@/projects/contrat-gestion/components/page-home.vue";

export default {
    data() {
        return {
            showApp: false,
        };
    },
    mounted() {
        let appsToShow = this.$store.state.webApplicationToShow;
        let currentApp = this.$route.fullPath.replace("/", "");
        if (appsToShow.includes(currentApp)) this.showApp = true;
    },
    components: {
        PageContratGestion,
    },
};
</script>
  
<style></style>